import { Button, Col, Form, OverlayTrigger, Row, Tooltip} from "react-bootstrap"
import { useTranslation } from "react-i18next"

export default function UserForm({state, handleInputChange, handleCheckboxChange, submit, isAddingOrEditing, isRegistering, disableEnableUsers}) {
    const { t } = useTranslation()

    return (
        <Form onSubmit={submit} className="px-4 formulario">
            <Row>
                <Col xs={12} md={6} className="my-2">
                    <Form.Label>{t('admin.users.username')}</Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='text'
                        name='username'
                        value={state.username ||  ''}
                        onChange={handleInputChange}
                        required
                    />
                </Col>
                <Col xs={12} md={6} className="my-2">
                    <Form.Label>{t('admin.users.email')}</Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='text'
                        name='email'
                        value={state.email ||  ''}
                        onChange={handleInputChange}
                        required
                    />
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={6} className="my-2">
                    <Form.Label>
                        {t('admin.users.password')} *&nbsp;
                        {isAddingOrEditing === 'editing' &&
                            <OverlayTrigger
                                placement="right"
                                delay={{ show: 250, hide: 400 }}
                                overlay={
                                    <Tooltip>
                                        {t('admin.users.passwordTooltip')}
                                    </Tooltip>
                                }
                                >
                                <i className="fas fa-info-circle"></i>
                            </OverlayTrigger>
                        }
                    </Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='text'
                        name='password'
                        value={state.password || ''}
                        onChange={handleInputChange}
                        required={isAddingOrEditing === 'adding' ? true : false}
                    />
                </Col>
                <Col xs={12} md={6} className="my-2">
                    <Form.Label>{t('admin.users.rol')}</Form.Label>
                    <Form.Control
                        className="sd-input"
                        as="select"
                        name="rol"
                        value={state.rol || ''}
                        onChange={handleInputChange}
                        required
                    >
                        <option value="Office">{t('admin.users.Office')}</option>
                        <option value="Laboratory">{t('admin.users.Laboratory')}</option>
                        <option value="Admin">{t('admin.users.Admin')}</option>
                    </Form.Control>
                </Col>
            </Row>
            <Row className="my-2">
                <Col xs={6}>
                    {isAddingOrEditing === 'editing' && (
                        <Button variant="fourth" className="my-2" onClick={(e) => disableEnableUsers(e)}>
                            {state?.active
                            ?
                            <><i className="fas fa-ban me-2"></i> {t('global.disable')}</>
                            :
                            <><i className="fas fa-check me-2"></i> {t('global.enable')}</>
                            }
                        </Button>
                    )}
                </Col>
                <Col xs={6} className="d-flex justify-content-end">
                    <Button variant='primary' type="submit" className="my-2">
                    {isRegistering
                        ?
                            <>
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </>
                        :
                            isAddingOrEditing === 'editing'
                            ?
                            <><i className="fas fa-edit me-2"></i> {t('global.edit')}</>
                            :
                            <><i className="fas fa-user-plus me-2"></i> {t('global.register')}</>
                    }
                    </Button>
                </Col>
            </Row>
        </Form>
    )
}